// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":root{--bodybg:#fff;--petrol1:#00649e;--petrol2:#3983a8;--logo:#2c2e33;--yazilar:#2c2e33}body,html{font-family:forma-djr-text,sans-serif!important;font-weight:400!important;font-style:normal!important;letter-spacing:.05rem!important}nav{padding:30px}nav a{font-weight:700;color:#2c3e50}nav a.router-link-exact-active{color:#42b983}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
